import screenshotSlider from './js/old/screenshotSlider';
import './scss/old-acf-blocks/screenshotslider.scss';

// Initialize components
document.addEventListener( 'DOMContentLoaded', () => {

	screenshotSlider();

} );

